import React from 'react'

const Footer: React.FC = () => {
  // Get version from package.json via environment variable
  const version = process.env.REACT_APP_VERSION || '0.0.0'
  
  // Get git commit hash from environment variable  
  const commitHash = process.env.REACT_APP_GIT_COMMIT || 'unknown'

  // Get current year for copyright
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gray-100 border-t border-gray-200 py-4 px-6 mt-8">
      <div className="text-center text-sm text-gray-600">
        © 2017 - {currentYear} Riddell Sports, Inc. All rights reserved
        <br />
        Version: {version} ({commitHash})
      </div>
    </footer>
  )
}

export default Footer
